import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import * as _ from "lodash";

@Injectable()
export class Dbutils {
    constructor(
        private db: AngularFireDatabase
    ) { }

    async branchIsExist(): Promise<any> {
        return (await this.db.database
            .ref("placeinfo")
            .once("value")).val();

    }

    public toppingIdExist(productId) {
        return (this.db.database
            .ref("toppings").orderByChild('productId').equalTo(productId));
    }

    public async getBranches(): Promise<any> {
        return (await this.db.database
            .ref("branches")
            .once("value")).val();
    }
    
    public async getoppingGroup(toppingGroupId) {
        return (await this.db.database
            .ref(`toppingsGroup/${toppingGroupId}/`).once("value")).val();
    }
}